"use strict";

require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = function _default(_ref) {
  var onNavOpen = _ref.onNavOpen,
    isNavOpen = _ref.isNavOpen;
  return /*#__PURE__*/_react["default"].createElement("button", {
    className: "navbar-toggle",
    disabled: isNavOpen,
    "data-flex-child": "x-center",
    onClick: onNavOpen
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "sr-only"
  }, " Toggle navigation "), /*#__PURE__*/_react["default"].createElement("div", {
    className: "icon-bar"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "icon-bar"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "icon-bar"
  }));
};